export default {
  TD: 'TD',
  GL: 'GL',
  TD_RV: 'TDRV',
  TD_MARINE: 'TDMARINE',
  TD_POWERSPORTS: 'TDPS',
  GL_RV: 'GLRV',
  GL_MARINE: 'GLMARINE',
  GL_POWERSPORTS: 'GLPS',
};
